import { render, staticRenderFns } from "./Dienstleister.vue?vue&type=template&id=4ed9974c&scoped=true&"
import script from "./Dienstleister.vue?vue&type=script&lang=js&"
export * from "./Dienstleister.vue?vue&type=script&lang=js&"
import style0 from "./Dienstleister.vue?vue&type=style&index=0&id=4ed9974c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9974c",
  null
  
)

export default component.exports